import { Beef, Coffee, Cookie, CupSoda, Drumstick, Egg, Fish, Flame, IceCream, Leaf, Salad, Sandwich, Soup, Utensils, Wheat } from "lucide-react";

export const CATEGORY_ICONS = { Flame, Soup, Salad, Beef, Fish, Drumstick, Wheat, Egg, Sandwich, CupSoda, Coffee, IceCream, Cookie, Leaf, Utensils };

export const LABELS = ["bestseller", "new", "spicy", "chef_pick"];
export const DIETS = ["vegetarian", "vegan", "gluten_free", "contains_nuts", "seafood", "dairy_free"];
